import {
  InsuranceCoverage,
  TrailerCoverage,
} from "Store/interfaces/products/coverage";
import { TextLanguage, TranslatedText } from "Store/texts/interfaces";

import { InjuriesFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/riskProductsInterfaces";
import { BaseProduct } from "Store/interfaces/products/checkPrice/BaseProduct";

export interface TrailerProductIntroFormValues {
  registrationYear: string;
  brand: string;
  model: string;
}

export interface TrailerProductDetailsFormValues extends InjuriesFormValues {
  coverageAmount: number;
}

export interface TrailerProductPriceFormValues {
  coverage: InsuranceCoverage;
}

export interface TrailerPriceRequestInfo extends BaseProduct {
  brand: string;
  model: string;
  coverageAmount: number;

  injuries: number;
  injuryYear?: number;
  year: number;

  dateOfBirth?: string;
}

export enum TrailerInsuranceType {
  TRAILER_FULL_OWN_DAMAGE = "trailerKasko",
  TRAILER_FIRE_AND_THEFT = "trailerFireAndTheft",
}

type TrailerTile = {
  productIntro: {
    ingress: TranslatedText;
  };
  productDetails: {
    heading: TranslatedText;
    ingress: TranslatedText;
  };
  productPrice: {
    heading: TranslatedText;
    ingress: TranslatedText;
    deductibleInfo: {
      title: TranslatedText;
      description: TranslatedText;
    };
  };
};

type TrailerFormTexts = {
  [key: string]: {
    label: TranslatedText;
    hint?: TranslatedText;
    placeholder?: TranslatedText;
    error: Record<string, TranslatedText>;
  };
};
export interface TrailerTexts {
  details: {
    [key: string]: Record<TextLanguage, string>;
  };
  formText: { checkPrice: TrailerFormTexts };
  tile: TrailerTile;
  title: TranslatedText;
  name: TranslatedText;
  types: {
    coverageGroup: Record<TrailerCoverage, TranslatedText>;
  };
}
